import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ERROR_DURATION } from 'constants/Global';

/**
 * Display error toaster/banner to user.
 */
export default class Error extends Component {
    /**
     * Creates an instance of Error.
     * @param {Object} props Props of component
     */
    constructor(props) {
        super(props);

        /**
         * State of react component.
         * @type {Object}
         */
        this.state = {
            appear: false,
        };
    }

    /**
     * React lifecycle.
     * Defer class for simulate animation.
     * @param {Object} prevProps Prev props of component
     */
    componentDidUpdate(prevProps) {
        const { discard, error } = this.props;

        if (prevProps.error && (!error || prevProps.error.ts !== error.ts)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ appear: false });
            clearTimeout(this.appearTimeout);
            clearTimeout(this.discardTimeout);

            /**
             * Appear timeout for simulating animation.
             * @type {Token}
             */
            this.appearTimeout = setTimeout(() => {
                this.setState({ appear: true });
            }, 300);

            /**
             * Discard timeout for removing error.
             * @type {Token}
             */
            this.discardTimeout = setTimeout(discard, ERROR_DURATION);
        }
    }

    /**
     * React lifecycle.
     * @return {ReactComponent}
     */
    render() {
        const { error, discard } = this.props;

        const errorClasses = classnames({
            error: true,
            'error--transition': this.state.appear,
        });

        return (
            <div className="error--wrapper">
                {error && error.content && (
                    <div className={errorClasses} role="alert">
                        {error.content}
                        <button type="button" className="btn btn--link" onClick={discard}>
                            <span className="icon-close error--close" />
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

Error.propTypes = {
    discard: PropTypes.func,
    error: PropTypes.shape({
        content: PropTypes.string,
        ts: PropTypes.number,
    }),
};
